<div class="card card-skinny" [ngClass]="getCourseStatus()">
  <div class="card-course-status" *ngIf="this.cheat && course?.status !== 'PUBLISHED'">
    {{ course?.status }} <i class="fa fa-check" *ngIf="course.purchased"></i>
  </div>
  <div class="card-footer-favorite">
    <button class="btn button-left" (click)="toggleFavorite($event, course)">
      <i class="fa fa-star-o"
         [ngClass]="{'fa-star':course?.progress?.userCourse?.favorite === true, 'fa-star-o': course?.progress?.userCourse?.favorite !== true}"></i>
    </button>
  </div>
  <div class="card-header" *ngIf="purchased"
       [ngStyle]="{'background-image': 'url('+ course?.thumbnailUrl + ')'}"
       title="{{course.shortName}}"
       aria-label="{{course.shortName}}"
       (click)="openCourse(course, course?.progress?.userCourse)">
  </div>
  <div class="card-footer" *ngIf="purchased">
    <div class="course-progress-container course-progress-container_white"
         *ngIf="course.displayPercentComplete !== false">
    </div>
    <div class="course-progress-container" *ngIf="course.displayPercentComplete !== false">
      <div class="course-progress-bar"
           [ngStyle]="{width: percentageComplete() + '%'}">
      </div>
    </div>
    <div class="card-footer-button">
      <a class="btn btn-no-padding" (click)="openCourse(course, course?.progress?.userCourse)">Launch Course</a>
    </div>
  </div>

  <div class="card-header" *ngIf="!purchased"
       [ngStyle]="{'background-image': 'url('+ course?.thumbnailUrl + ')'}"
       title="{{course.shortName}}"
       aria-label="{{course.shortName}}"
       (click)="course.requireRegistrationForPreview?signup(course):openCourse(course, course?.progress?.userCourse)">
  </div>

  <div class="card-footer" *ngIf="!purchased">
    <div class="card-footer-button" *ngIf="!course.requireRegistrationForPreview">
      @if (course.inCoursePurchaseEnabled && !course.deepLinkToMarketing) {
        <a class="btn btn-no-padding" (click)="onBuyClick($event)"
           [innerText]="course.buyLinkText?course.buyLinkText:'Purchase'"></a>
      } @else if (course.inCoursePurchaseEnabled && course.deepLinkToMarketing) {
        <a class="btn btn-no-padding"
           (click)="openCourse(course, course?.progress?.userCourse)"
           [innerText]="course.buyLinkText?course.buyLinkText:'Purchase'"></a>
      } @else if (course.webPurchaseUrl){
        <a class="btn btn-no-padding" [href]="course.webPurchaseUrl" target="_blank"
           [innerText]="course.buyLinkText?course.buyLinkText:'Purchase'"></a>
      } @else {
        <a class="btn btn-no-padding" (click)="openCourse(course, course?.progress?.userCourse)"
           [innerText]="course.buyLinkText?course.buyLinkText:'Purchase'"></a>
      }
      <a class="btn btn-no-padding" *ngIf="course.demoUrl !== null"
         id="{{course.webAppId}}"
         (click)="openCourse(course, course?.progress?.userCourse)">Preview</a>
    </div>
    <div class="card-footer-button" *ngIf="course.requireRegistrationForPreview">
      <a class="btn btn-no-padding" (click)="signup(course)">Sign Up</a>
    </div>
  </div>
</div>
